<div class="policy-mcp-server-filtering">
  <div class="policy-mcp-server-filtering-add" *ngIf="(isLoading$ | async) === false">
    <div class="policy-mcp-server-filtering-add-text">
      <div class="policy-mcp-server-filtering-add-text-description">
        {{ 'policyPage.config.mcpServerFilteringContent.allowedMcpServersDesc' | labelsProvider }}
      </div>
    </div>
    <div class="policy-mcp-server-filtering-add-button" *ngIf="editable">
      <button class="add-mcp-server-button" (click)="addMcpServerClicked()">
        <span>{{ 'policyPage.config.mcpServerFilteringContent.addMcpServer' | labelsProvider }}</span>
      </button>
    </div>
  </div>
  <div class="divider" *ngIf="(isLoading$ | async) === false"></div>
  <div class="policy-mcp-server-filtering-table-section" *ngIf="(isLoading$ | async) === false">
    <div class="policy-mcp-server-filtering-table-section-title">
      {{ 'policyPage.config.mcpServerFilteringContent.allowedMcpServers' | labelsProvider }}
    </div>
    <app-effective-policy-settings-button
      class="policy-field-effective-policy-settings-button"
      [effectivePolicySetting]="EffectivePolicySettingEnum.mcpServers"
      [platform]="integrationModel.platform"
    >
    </app-effective-policy-settings-button>
    <div class="policy-mcp-server-filtering-table-section-body" *ngIf="(isLoading$ | async) === false">
      <div class="policy-mcp-server-filtering-table-section-body-search">
        <app-autocomplete-search
          class="policy-mcp-server-filtering-table-section-body-search-box"
          placeholder="Search..."
          (autocompleteOnChange)="mcpServerSearched($event)"
          [values]="mcpServersUrls"
          [resetSearchBox$]="resetSearchBoxBehavioralSubject$"
        ></app-autocomplete-search>
      </div>

      <p-table [scrollable]="true" [value]="(mcpServersCurrentPage$ | async) ?? []" class="main-table">
        <ng-template pTemplate="header">
          <tr>
            <th>MCP Server</th>
            <!-- Actions Column -->
            <th style="width: 50px"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-mcpServer>
          <tr class="table-row">
            <td style="width: 100%">{{ mcpServer.url }}</td>

            <td style="width: 50px">
              <div class="delete-column-icon" (click)="$event.stopPropagation()">
                <img
                  *ngIf="editable"
                  src="assets/images/common/delete.svg"
                  class="delete-icon"
                  (click)="enableRemoveMcpServer && removeMcpServerClicked(mcpServer)"
                  [matTooltip]="
                    !enableRemoveMcpServer ? ('policiesPage.deleteButtonTextHoverText' | labelsProvider) : ''
                  "
                />
              </div>
            </td>
          </tr>
        </ng-template>
        <!-- When the table is empty ( data length 0) we get here -->
        <ng-template pTemplate="emptymessage">
          <app-no-data [tableNotFoundText]="tableNotFoundText" [tableNotFoundIcon]="tableNotFoundIcon"></app-no-data>
        </ng-template>
      </p-table>
    </div>
  </div>

  <app-form-footer
    *ngIf="editable"
    [changesWereDone]="changesWereDone"
    (saveChanges)="saveChanges()"
    (resetChanges)="resetForm()"
    (goBack)="goBack.emit()"
  >
  </app-form-footer>
</div>
